import Vue from 'vue';
export const addLabel = (card, domData, emitMethods) => {
    const outDom = document.createElement('div');
    outDom.style.pointerEvents = 'none';
    const dom = document.createElement('div');
    outDom.appendChild(dom);
    const Tool = Vue.extend(card);
    const tool = new Tool(Object.assign({}, domData));
    tool.$mount(dom);
    if (tool.$el) {
        tool.$el.style.pointerEvents = 'auto';
    }
    else {
        console.info('组件实例必须存在，切勿用v-if等销毁组件的方式控制顶层数据显示隐藏');
    }
    if (emitMethods) {
        for (const i in emitMethods) {
            tool.$on(i, emitMethods[i]);
        }
    }
    return outDom;
};
